/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TotalInsuranceClaim/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TotalInsuranceClaim({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/InsuranceSummary/Content/TotalInsuranceClaim"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let paymentPlanValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
format: fromHelpers.getValue,
})
  return (<React.Fragment
>
<div
  data-testid="TotalInsuranceClaim.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z152Iaw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-2-Z152Iaw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-Z152Iaw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Total insurance claim"
 color={dtColorsBlack}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan"
 format="helpers.js getValue"
 text={paymentPlanValueData}
 weight="medium"
 color={dtColorsBlack}
/>
</div>
{children}
</React.Fragment>)
}